import type { GaugeMetricData } from '@/warranty/domain/entities/gauge-metric';

export const getGaugeSeries = (
  data: GaugeMetricData,
): Highcharts.SeriesOptionsType[] => [
  {
    name: data.id,
    type: 'gauge',
    data: [
      {
        // 🎨 use fallback 100% for SOH if no YTD value
        y:
          data.yearToDate !== undefined
            ? Math.round(data.yearToDate)
            : data.id === 'SOH'
              ? 100
              : undefined,
        // pass through for tooltip access
        ...({
          yearToDate: data.yearToDate,
          endOfYearPrediction: data.futurePrediction,
          zones: data.zones,
        } as any),
      },
    ],
    animation: false,
    stickyTracking: false,
    enableMouseTracking: true,
    dial: {
      baseLength: '0%',
      rearLength: '0%',
      radius: '100%',
      baseWidth: 2,
      topWidth: 2,
      backgroundColor: '#000000',
    },
    pivot: {
      backgroundColor: '#000000',
      radius: 4,
    },
  },
];
